function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export default (function () {
  var propTypes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return Object.keys(props).filter(function (prop) {
    return !propTypes.hasOwnProperty(prop);
  }).reduce(function (previousValue, currentValue) {
    return Object.assign(previousValue, _defineProperty({}, currentValue, props[currentValue]));
  }, {});
});